"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions = {
    LOAD_DATA: 'INITIAL/LOAD_DATA',
};
exports.default = actions;
//# sourceMappingURL=actions.js.map